import r from"./_assocIndexOf.js";var t=r,a=Array.prototype.splice;var e=function(r){var e=this.__data__,o=t(e,r);return!(o<0)&&(o==e.length-1?e.pop():a.call(e,o,1),--this.size,!0)};export{e as default};
//# sourceMappingURL=_listCacheDelete.js.map
